import { Injectable } from "@angular/core";
import { SearchGroup, Status, translateCommonErrorStatus } from "@core/data";
import { AdvancedReportCompilerService } from '@core/data/api/reports/advanced-report-compiler.service';
import { TableComponentData } from "@core/data/types/Reports/report-tables";
import { Calculation, Characteristic, Index, Measurement, Property } from '@library';
import { Action, State, StateContext } from "@ngxs/store";
import { SizeClassification } from 'library/src/classifications/_types';
import { tap } from 'rxjs/operators';

export interface ReportTableFormStateModel {
    key: string;
    data: TableComponentData;
    status: Status;

    calculations: SearchGroup<Calculation>[];
    characteristics: SearchGroup<Characteristic>[];
    indexes: SearchGroup<Index>[];
    measures: SearchGroup<Measurement>[];
    properties: SearchGroup<Property>[];
    classifications: SearchGroup<SizeClassification>[];

    //? NEEDED FOR COMPILATIONS
    reportKey: string;
    ownerOrgKey: string;
}

const DEFAULTS: ReportTableFormStateModel = {
    key: null,
    data: null,

    status: Status.UNINITIALIZED,

    calculations: [],
    characteristics: [],
    indexes: [],
    measures: [],
    properties: [],
    classifications: [],

    reportKey: null,
    ownerOrgKey: null,
}

export class InitReportTableForm {
    static readonly type = "[ReportTableForm] Init";
    constructor(public reportKey: string, public ownerOrgKey: string, public optionKey: string, public data: TableComponentData) {}
}

export class LoadTableFormState {
    static readonly type = "[ReportTableForm] Load";
    constructor() {}
}

@State<ReportTableFormStateModel>({
    name: 'advanced_report_table_form',
    defaults: DEFAULTS,
})
@Injectable()
export class ReportTableFormState {

    constructor(
        private _compilerService: AdvancedReportCompilerService,
    ) {}

    @Action(InitReportTableForm)
    initReportTableForm(ctx: StateContext<ReportTableFormStateModel>, action: InitReportTableForm) {

        ctx.setState({
            ...DEFAULTS,
            key: action.optionKey,
            data: action.data,
            reportKey: action.reportKey,
            ownerOrgKey: action.ownerOrgKey,
            status: Status.LOADING,
        });

        ctx.dispatch(LoadTableFormState);
    }

    @Action(LoadTableFormState)
    loadTableFormState(ctx: StateContext<ReportTableFormStateModel>, action: LoadTableFormState) {
        let state = ctx.getState();

        ctx.patchState({
            status: Status.LOADING,
        });

        return this._compilerService.tableOptions(state.reportKey, state.ownerOrgKey)
            .pipe(
                tap(
                    result => {
                        ctx.patchState({
                            status: Status.OK,
                            calculations: result.calculations || [],
                            characteristics: result.characteristics || [],
                            indexes: result.indexes || [],
                            measures: result.measures || [],
                            properties: result.properties || [],
                            classifications: result.classifications || [],
                        });
                    }, error => {
                        ctx.patchState({
                            status: translateCommonErrorStatus(error),
                            calculations: [],
                            characteristics: [],
                            indexes: [],
                            measures: [],
                            properties: [],
                        });
                    }
                )
            )
    }

}